<template>
  <div class="c-lookup-lang__wrapper">
    <div v-if="responsive === 'desktop'">
      <button
        ref="dropdown"
        class="c-lookup-lang__button"
        :class="isDropdownOpen ? 'c-lookup-lang__button--open' : ''"
        @click="isDropdownOpen = !isDropdownOpen">
        {{ selected.name }}
        <arrow class="c-lookup-lang__icon-arrow" />
      </button>
      <div class="c-lookup-lang__dropdown"
        v-click-outside="{
          exclude: ['dropdown'],
          handler: 'closeDropdown'
        }"
        :class="isDropdownOpen ? 'c-lookup-lang__dropdown--open' : ''">
        <div class="c-lookup-lang__dropdown-wrapper">
          <button
            v-for="lang in languages"
            :key="lang.props.code"
            class="c-lookup-lang__option"
            :class="lang.props.code === selected.code ? 'c-lookup-lang__option--selected' : ''"
            @click="switchLang(lang.props)">
            {{ lang.props.name }}
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <select
        class="c-lookup-lang__button"
        @change="switchLang"
        v-model="selected.code">
        <option
          v-for="lang in languages"
          :key="lang.props.code"
          :value="lang.props.code">
          {{ lang.props.name }}
        </option>
      </select>
      <arrow class="c-lookup-lang__icon-arrow" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Arrow from '@/assets/svg/Arrow'

export default {
  name: 'LookUpLanguageSelect',

  components: {
    'arrow': Arrow
  },

  computed: {
    ...mapState('userSettings', {
      responsive: state => state.responsive
    }),
  },

  data() {
    return {
      isDropdownOpen: false
    }
  },

  props: {
    languages: Array,
    selected: {}
  },

  methods: {
    switchLang(lang) {
      if(this.responsive !== 'desktop') {
        const chosenLang = this.languages.find(language => language.props.code === lang.target.value)

        lang = {
          name: chosenLang.props.name,
          code: lang.target.value
        }
      }
      this.$emit('lang-changed', { name: lang.name, code: lang.code })
      this.isDropdownOpen = false
    },

    closeDropdown() {
      this.isDropdownOpen = this.isDropdownOpen ? !this.isDropdownOpen : this.isDropdownOpen
    }
  },

  mounted() {
    const button = document.querySelector('.c-lookup-lang__button')
    if(button) {
      button.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_vars.scss';
  @import '@/assets/scss/_mixin.scss';

  .c-lookup-lang__wrapper {
    position: relative;
  }

  .c-lookup-lang__button {
    @include btnReset();
    background-color: $white;
    border-radius: 1em;
    border: 2px solid $blue;
    padding: 0 1em;
    line-height: 1.75em;
    text-align: left;
    width: 100%;
    color: $blue;
    cursor: pointer;
    &.c-lookup-lang__button--open {
      border-radius: 1em 1em 0 0;
      border-bottom: 0;
    }
    &:focus {
      @include a11yOutline();
    }
  }
  .c-lookup-lang__dropdown {
    background-color: $white;
    border: 2px solid $blue;
    border-top: 0;
    border-radius: 0 0 1em 1em;
    left: 0;
    right: 0;
    display: none;
    color: $blue;
    position: absolute;
    padding-right: 1px;
    top: 1.7em;
    max-height: 15em;
    overflow: hidden;
    z-index: 1;
    &.c-lookup-lang__dropdown--open {
      display: block;
    }
    .c-lookup-lang__dropdown-wrapper {
      overflow-y: auto;
      height: auto;
      max-height: 15em;
      padding:0 1em;
    }
    .c-lookup-lang__option {
      @include btnReset();
      cursor: pointer;
      display: block;
      line-height: 1.5em;
      width: 100%;
      position: relative;
      text-align: left;
      &.c-lookup-lang__option--selected {
        display: none;
      }
      &:focus {
        @include a11yOutline();
      }
    }
  }
  .c-lookup-lang__icon-arrow {
    position: absolute;
    top: -.5em;
    right: .25em;
  }
</style>
